import { h } from 'preact';
import { removeFromWishlist } from './index';
import { t } from '../theme/locales';
export const Button = ({ children , innerLabel =t('wishlist.add_to_wishlist') , className ='button__wishlist' , ariaControls ='wishlist-modal' , isInWishlist , modalSize ='small' , onClick , epi , empi , du , customerId , onRemoveFromWishlist  })=>{
    const handleRemoveClick = async (e)=>{
        e.preventDefault();
        e.stopPropagation();
        const swat = window._swat;
        if (!swat) {
            console.error('Swym API not initialized');
            return;
        }
        const lid = window.swymSelectedListId;
        if (!lid || !epi || !empi || !du) {
            console.error('Missing wishlist or product information');
            return;
        }
        const product = {
            epi,
            empi,
            du
        };
        await removeFromWishlist(lid, swat, product);
        if (onRemoveFromWishlist) {
            onRemoveFromWishlist();
        }
    };
    const inner = [
        h('svg', {
            width: '18',
            height: '16',
            viewBox: '0 0 18 16',
            fill: 'none',
            xmlns: 'http://www.w3.org/2000/svg'
        }, [
            h('path', {
                d: 'M0.625 5.29251C0.625017 4.35092 0.906328 3.43147 1.43178 2.65561C1.95723 1.87976 2.7021 1.28399 3.56801 0.947006C4.43392 0.610018 5.38013 0.54766 6.28168 0.768167C7.18322 0.988675 7.99769 1.48167 8.6175 2.18205C8.66116 2.22945 8.71393 2.26724 8.77256 2.29307C8.83119 2.3189 8.89442 2.33223 8.95833 2.33223C9.02225 2.33223 9.08547 2.3189 9.1441 2.29307C9.20273 2.26724 9.25551 2.22945 9.29917 2.18205C9.91703 1.47712 10.7317 0.979979 11.6347 0.756793C12.5377 0.533606 13.4862 0.594962 14.3541 0.932693C15.2219 1.27042 15.9678 1.86851 16.4926 2.64735C17.0174 3.4262 17.2961 4.34885 17.2917 5.29251C17.2917 7.23021 16.0417 8.67713 14.7917 9.94636L10.215 14.442C10.0597 14.6231 9.86827 14.7685 9.65337 14.8687C9.43847 14.9689 9.20504 15.0215 8.96857 15.023C8.73211 15.0245 8.49804 14.9749 8.28191 14.8775C8.06577 14.7801 7.87252 14.6371 7.715 14.4581L3.125 9.94636C1.875 8.67713 0.625 7.23867 0.625 5.29251Z',
                stroke: '#11294A',
                strokeWidth: '1.25',
                strokeLinecap: 'round',
                strokeLinejoin: 'round'
            })
        ])
    ];
    return h('button', {
        type: 'button',
        className: className,
        'data-testid': 'wishlist-button',
        'data-customerid': customerId,
        onClick: isInWishlist && epi && empi && du ? handleRemoveClick : onClick,
        'data-wishlist-button': isInWishlist,
        'data-modal-size': modalSize,
        'aria-controls': ariaControls
    }, [
        ...inner,
        h('span', {}, innerLabel),
        children
    ]);
};
export default Button;
